/** @format */

export const GET_REDEEM_REQUEST = "GET_REDEEM_REQUEST";

export const REDEEM_ACTION = "REDEEM_ACTION";

export const GET_SELLER_WITHDRAWAL_REQUEST = "GET_SELLER_WITHDRAWAL_REQUEST";

export const ADMIN_WALLET = "ADMIN_WALLET";

export const ACCEPTSELLERWITHDRAWALREQUEST = "ACCEPTSELLERWITHDRAWALREQUEST";

export const GET_ADMIN_EARNING = "GET_ADMIN_EARNING";

export const DECLINESELLERWITHDRAWALREQUEST = "DECLINESELLERWITHDRAWALREQUEST";

// Paystack transfer
export const TRANSFER_REQUIRES_OTP = "TRANSFER_REQUIRES_OTP";
export const TRANSFER_OTP_FINALIZED = "TRANSFER_OTP_FINALIZED";
export const SET_PAYSTACK_BALANCE = "SET_PAYSTACK_BALANCE";
export const SET_TRANSFER_STATUS = "SET_TRANSFER_STATUS";
